var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('navigation-bar'),_c('v-main',{staticClass:"grey lighten-2"},[_c('v-sheet',{attrs:{"id":"main-content"}},[_c('v-container',[_c('v-row',[_c('v-col',{staticClass:"mt-2",attrs:{"cols":"12"}},[_c('router-view')],1)],1)],1)],1)],1),_c('codettes-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }